/** @jsxImportSource theme-ui */
import { jsx, Container, Box } from 'theme-ui'
import { ContentfulFaq, Question } from './Question'
import React, { Fragment, useState } from 'react'
import 'react-slidedown/lib/slidedown.css'
import { Styled } from '~/components/styled'
import Head from 'next/head'
import { useRouter } from 'next/router'

type Props = ContentfulFaq

export default function FAQ({ questions, title }: Props) {
  const [openQuestion, setOpenQuestion] = useState<string | null>(null)
  const {asPath} = useRouter()
  const isFAQPage = asPath === '/faq';

  const extractTextFromRichText = (json: any): string => {
    if (!json || !Array.isArray(json.content)) return '';

    return json.content
      .map((block: any) => {
        if (block.nodeType === 'paragraph' && Array.isArray(block.content)) {
          return block.content
            .map((child: any) => (child.nodeType === 'text' ? child.value : ''))
            .join('');
        }
        return '';
      })
      .join('\n')
      .trim();
  }

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": questions.map((question, i) => ({
      "@type": "Question",
      "name": question.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": extractTextFromRichText(question.answer?.json),
      },
    })),
  };

  return (
    <React.Fragment>
      {
        isFAQPage && (
          <Head>
            <script type="application/ld+json">
              {JSON.stringify(schema)}
            </script>
          </Head>
        )
      }
      <Box sx={{ marginY: 5, paddingBottom: 5 }}>
        <Container sx={{ maxWidth: 10, paddingX: 2 }}>
          <Styled.h2 sx={{ textAlign: 'center', fontSize: 6 }}>{title}</Styled.h2>
          <Box
            sx={{
              // borderRadius: 3,
              overflow: 'hidden',
              // boxShadow: 'header',
            }}
          >
            {questions.map((question, i) => (
              <Fragment key={question.id}>
                <Question
                  index={i}
                  isOpen={question.id === openQuestion}
                  onClick={() =>
                    setOpenQuestion((state) =>
                      state === question.id ? null : question.id
                    )
                  }
                  {...question}
                />
                {/* {i !== questions.length - 1 && (
                  <Box sx={{ height: '3px', bg: 'text' }} marginY={0} />
                )} */}
              </Fragment>
            ))}
          </Box>
        </Container>
      </Box>
    </React.Fragment>
  )
}
